export default __webpack_public_path__ + "static/media/icon-salvar.32ef73cd.svg";